import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BlogService } from 'src/app/services/blog.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  date = new Date()
  public url: any;
  logo

  constructor(
    private router: Router,
    public blogService: BlogService,
    private translateService: TranslateService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
    });
  }


  ngOnInit() {
    this.getLogo()
    this.translateService.onLangChange.subscribe(data => {
      this.getLogo()
    })
  }

  getLogo() {
    if(this.translateService.currentLang == 'zh') {
      this.logo = 'assets/custom/images/logo_zh.png'
    }
    else {
      this.logo = 'assets/custom/images/logo.png'
    }
  }

}
